import {
    createSlice,
} from '@reduxjs/toolkit'

const initialState = {
    isSearching: false,
    fass: [],
}

const assetSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {
        clearAssetSearch(state, action) {
            state.isSearching = false
            state.fass.length = 0
        },
        setAssetSearching(state, action) {
            state.isSearching = action.payload
        },
        setAssetSearch(state, action) {
            state.isSearching = false
            let arr = action.payload
            if (!!arr) {
                state.fass = arr.sort((a, b) => a.desc.localeCompare(b.desc))
            } else {
                state.fass.length = 0
            }
        },
    },
})

export const {
    setAssetSearching, setAssetSearch, clearAssetSearch
} = assetSlice.actions
export const assSearching = (state) => state.asset.isSearching
export const assSrchState = (state) => state.asset.fass

export default assetSlice.reducer
